import React from 'react';
export function Footer() {
  return <footer id="contact" className="bg-slate-950 text-slate-400 py-12 border-t border-slate-800" data-id="element-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-11">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8" data-id="element-12">
          <div data-id="element-13">
            <h2 className="text-2xl font-bold text-white tracking-tighter mb-4" data-id="element-14">
              TWICE BOURNE
            </h2>
            <p className="text-sm max-w-xs" data-id="element-15">
              A diverse portfolio of premium brands delivering excellence across
              real estate, entertainment, apparel, and hospitality.
            </p>
          </div>

          <div data-id="element-16">
            <h3 className="text-lg font-semibold text-white mb-4" data-id="element-17">
              Our Brands
            </h3>
            <ul className="space-y-2 text-sm" data-id="element-18">
              <li data-id="element-19">
                <a href="#" className="hover:text-white transition-colors" data-id="element-20">
                  Saint Lucia
                </a>
              </li>
              <li data-id="element-21">
                <a href="#" className="hover:text-white transition-colors" data-id="element-22">
                  Barndormitory Holdings LLC
                </a>
              </li>
              <li data-id="element-23">
                <a href="#" className="hover:text-white transition-colors" data-id="element-24">
                  Entertainment Films
                </a>
              </li>
              <li data-id="element-25">
                <a href="#" className="hover:text-white transition-colors" data-id="element-26">
                  Apparels
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-27">
            <h3 className="text-lg font-semibold text-white mb-4" data-id="element-28">Contact</h3>
            <ul className="space-y-2 text-sm" data-id="element-29">
              <li data-id="element-30">contact@twicebourne.com</li>
              <li data-id="element-31">1-800-TWICE-BRN</li>
              <li data-id="element-32">Global Headquarters</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row justify-between items-center gap-4 text-sm" data-id="element-33">
          <p data-id="element-34">
            &copy; {new Date().getFullYear()} Twice Bourne. All rights reserved.
          </p>
          <div className="flex space-x-6" data-id="element-35">
            <a href="#" className="hover:text-white transition-colors" data-id="element-36">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-37">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}